<template>
  <div class="search-results__none">

    <!-- No Results Message -->
    <p>Oops - it looks like we have nothing available with the filters you have selected. Please try removing some filters to see more residences.</p>

    <!-- Clear Filters -->
    <search-clear-filters v-if="isFiltering" link-classes="btn bg-b-blue" />
  </div>
</template>
<script>
  export default {
    name: 'SearchNoResults',
    props: {
      isFiltering: Boolean
    },
  }
</script>
